import React, { useState } from 'react';
import styled from 'styled-components';

const MakkaraWrapper = styled.div`
  display: block;
  width: 200px;
  height: 80px;
  position: relative;
  &:hover {
      cursor: pointer;
  }
`

const Text = styled.p`
    margin: 0;
    padding: 0;
    position: absolute;
    left: 0;
    right: 0;
    text-align: center;
    top: ${props => props.top}px;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: '#fff';
    text-transform: uppercase;
    font-family: 'Barlow', sans-serif !important;
    font-size: 15px !important;
    font-weight: 600;
    z-index: 9;
`

const MakkaraButton = props => {
    const { strokeColor, fillColor, strokeWidth, text, strokeOnHover, fillOnHover, rotate, top } = props
    const [hover, setHover] = useState(false)
    return (
        <MakkaraWrapper
            onMouseOver={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
        >
            <Text
                hover={hover}
                top={top}
            >
                {text}
            </Text>
            <svg
                version="1.1"
                id="Layer_1" x="0px"
                y="0px"
                viewBox="0 0 220 100"
                stroke={hover ? strokeOnHover : strokeColor}
                strokeWidth={strokeWidth}
                fill={hover ? fillOnHover : '#312450'}
                style={{
                    transform: `rotate(${rotate}deg)`
                }}
            >
            <g>
                <path class="st0" d="M193.57,22.28L193.57,22.28c-9.3-9.33-23.71-10.78-34.89-3.85c-30.59,18.95-69.62,18.95-100.21,0
                    c-11.19-6.93-25.6-5.48-34.89,3.85l0,0c-12.66,12.71-10.5,34.08,4.69,43.61c24.47,15.35,52.39,23.03,80.31,23.03
                    c27.92,0,55.84-7.68,80.31-23.03C204.07,56.36,206.23,34.98,193.57,22.28z"/>
                <g>
                    <g>
                        <path class="st1" d="M23.31,22.34c-0.6-3.56-1.04-7.14-1.33-10.74c-0.15-1.91-3.16-1.93-3,0c0.31,3.87,0.79,7.71,1.43,11.54
                            C20.74,25.04,23.63,24.24,23.31,22.34L23.31,22.34z"/>
                    </g>
                </g>
                <g>
                    <g>
                        <path class="st1" d="M21.44,21.01c-4.8,0.73-9.39,2.19-13.99,3.71c-1.82,0.6-1.04,3.5,0.8,2.89c4.6-1.52,9.19-2.98,13.99-3.71
                            C24.14,23.61,23.33,20.72,21.44,21.01L21.44,21.01z"/>
                    </g>
                </g>
                <g>
                    <g>
                        <path class="st1" d="M8.59,26.99c1.32-1.64,2.9-3.33,3.88-5.2c0.88-1.67,0.92-3.51,0.86-5.36c-0.06-1.93-3.06-1.93-3,0
                            c0.05,1.58,0.07,3.02-0.79,4.42c-0.88,1.42-2.03,2.72-3.07,4.02C5.27,26.36,7.38,28.49,8.59,26.99L8.59,26.99z"/>
                    </g>
                </g>
                <g>
                    <g>
                        <path class="st1" d="M12,17.8c3.85-0.15,7.25-2.1,9.32-5.35c1.04-1.63-1.56-3.14-2.59-1.51c-1.49,2.34-3.96,3.76-6.73,3.87
                            C10.07,14.88,10.06,17.88,12,17.8L12,17.8z"/>
                    </g>
                </g>
                <g>
                    <g>
                        <path class="st1" d="M198.36,28.17c3.56-0.6,7.14-1.04,10.74-1.33c1.91-0.15,1.93-3.16,0-3c-3.87,0.31-7.71,0.79-11.54,1.43
                            C195.66,25.59,196.47,28.49,198.36,28.17L198.36,28.17z"/>
                    </g>
                </g>
                <g>
                    <g>
                        <path class="st1" d="M199.69,26.29c-0.73-4.8-2.19-9.39-3.71-13.99c-0.6-1.82-3.5-1.04-2.89,0.8c1.52,4.6,2.98,9.19,3.71,13.99
                            C197.09,28.99,199.98,28.19,199.69,26.29L199.69,26.29z"/>
                    </g>
                </g>
                <g>
                    <g>
                        <path class="st1" d="M194.42,13.98c1.1,0.87,2.09,1.88,3.2,2.73c1.68,1.3,3.8,1.33,5.84,1.26c1.93-0.06,1.93-3.06,0-3
                            c-1.63,0.05-3.15,0.12-4.43-0.96c-0.84-0.71-1.63-1.48-2.49-2.16C195.04,10.67,192.91,12.78,194.42,13.98L194.42,13.98z"/>
                    </g>
                </g>
                <g>
                    <g>
                        <path class="st1" d="M202.55,16.69c0.15,3.85,2.1,7.25,5.35,9.32c1.63,1.04,3.14-1.56,1.51-2.59c-2.34-1.49-3.76-3.96-3.87-6.73
                            C205.48,14.76,202.48,14.75,202.55,16.69L202.55,16.69z"/>
                    </g>
                </g>
            </g>
            </svg>
        </MakkaraWrapper>
    )
}

export default MakkaraButton